import { useFeatureFlag } from "@src/backpack-console/featureFlags";
import { isStorybook, VITE_LD_CLIENT_ID } from "@src/env";
import { useFeatureFlagsReady } from "@src/featureFlags";
import { Loader } from "@src/global_components";
import { useLDClient } from "launchdarkly-react-client-sdk";
import { ReactNode, useEffect, useState } from "react";

const LAUNCH_DARKLY_WAIT_MS = 3000;
const isLaunchDarklyEnabled = !!VITE_LD_CLIENT_ID && !isStorybook;

export default function AuthDesignRefreshGate({
  refreshed,
  legacy,
}: Readonly<{ refreshed: ReactNode; legacy: ReactNode }>) {
  const isAuthDesignRefresh =
    useFeatureFlag("auth-design-refresh", "off") === "v1";
  const featureFlagsReady = useFeatureFlagsReady();
  const client = useLDClient();
  const [stoppedWaiting, setStoppedWaiting] = useState(false);
  const isWaitingForClient =
    isLaunchDarklyEnabled && !client && !stoppedWaiting;

  useEffect(() => {
    if (!isWaitingForClient) return;
    const timeout = setTimeout(
      () => setStoppedWaiting(true),
      LAUNCH_DARKLY_WAIT_MS
    );
    return () => clearTimeout(timeout);
  }, [isWaitingForClient]);

  if (isWaitingForClient || !featureFlagsReady) return <Loader size={80} />;

  return <>{isAuthDesignRefresh && !stoppedWaiting ? refreshed : legacy}</>;
}
